import {
  Assignment,
  BarChart,
  Book,
  Campaign,
  DriveFileMove,
  FileCopy,
  Group,
  Groups,
  Hive,
  PieChart,
  PrecisionManufacturing,
  Receipt,
  RunningWithErrors,
  Theaters,
} from '@mui/icons-material'
import { LXYoutubeIcon } from '../components/LXYoutubeIcon'

export const MenuHelper = {
  icons: {
    beneficiaries: Group,
    youtubeChannels: LXYoutubeIcon,
    products: Book,
    compilations: Hive,
    artworks: Theaters,
    youtubeRawImports: Assignment,
    statements: Receipt,
    analytics: BarChart,
    quotas: PieChart,
    quotasError: RunningWithErrors,
    exports: DriveFileMove,
    videoPromotion: Campaign,
    fileCopy: FileCopy,
    users: Groups,
    automatedTreatments: PrecisionManufacturing,
  },
}
